export default __webpack_public_path__ + "static/media/bluebg.267e62d9.jpg";